import { Template } from './template';
export interface itemOrderReceiving {
  id: string;
  receivingId: string;
  isActive: boolean;
  departmentId: string;
  customerId: string;
  receivingWorkflows: Template[];
}
export interface itemOrderReturn {
  id: string;
  inwardID: string;
  isActive: true;
  departmentId: string;
  customerId: string;
  returnWorkflows: Template[];
}
export const initialOrderReceiving = {
  id: '',
  receivingId: '',
  isActive: false,
  departmentId: '',
  customerId: '',
  receivingWorkflows: [],
};
